import React from 'react';
import cn from 'classnames';
import { useQuoteContext } from '@/dataroom/app/landing/QuoteContext';
import GetStartedButton from '@/dataroom/ui/components/Landing/common/GetStartedButton';
import { DataroomURL } from '@/dataroom/infrastructure/dataroomUrl';
import Tooltip from '@dealroadshow/uikit-tooltip';
import IconDownload from '@dealroadshow/uikit-icon/IconDownload';
import IconPrint from '@dealroadshow/uikit-icon/IconPrint';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import styles from './quoteFormSuccess.module.scss';

const QuoteFormSuccess = () => {
  const {
    submittedFormValues,
  } = useQuoteContext();

  const {
    estimatedDuration,
    estimatedSize,
    companyName,
    fullName,
    userEmail,
    phoneNumber,
    quote,
    printLink,
  } = submittedFormValues;

  return (
    <div
      className={ styles.successMessageWrp }
      data-test="getQuoteSuccessMessage"
    >
      <h2 className={ styles.thanksHeaderWrp }>Thank you!</h2>
      <div className={ styles.description }>
        Please find your quote and our standard engagement letter below.<br />
        If you need more details,
        please <a href={ DataroomURL.getContactUsUrl() } target="_blank">Contact Us</a>
      </div>
      <div className={ styles.resultWrp }>
        <table
          className={ styles.resultContent }
          data-test="infoTable"
        >
          <tbody>
            <tr>
              <td>Estimated Duration:</td>
              <td>{ estimatedDuration }</td>
            </tr>
            <tr>
              <td>Estimated Size:</td>
              <td>{ estimatedSize }</td>
            </tr>
            <tr>
              <td>Your Company:</td>
              <td>{ companyName }</td>
            </tr>
            <tr>
              <td>Your Name:</td>
              <td>{ fullName }</td>
            </tr>
            <tr>
              <td>Your Email:</td>
              <td>{ userEmail }</td>
            </tr>
            <tr>
              <td>Phone Number:</td>
              <td>{ phoneNumber }</td>
            </tr>
          </tbody>
        </table>
        <div className={ styles.divider } />
        <table className={ styles.resultContent }>
          <tbody>
            <tr>
              <td>Your Quote:</td>
              <td>
                <span className={ styles.quoteValue }>{ quote }</span>
                <a
                  href={ printLink }
                  target="_blank"
                  className={ styles.print }
                >
                  <Tooltip
                    content="Print"
                    className={ styles.tooltip }
                  >
                    <IconPrint className={ styles.printIcon } />
                  </Tooltip>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={ styles.buttonWrp }>
          <GetStartedButton className={ cn(spacesStyles.mrn, styles.button) } />
        </div>
      </div>
      <div className={ styles.downloadWrp }>
        <a
          className={ styles.downloadLink }
          href="/documents/Finsight_Engagement_Letter.docx"
          data-prevent-progress="true"
        >
          <IconDownload
            className={ styles.downloadIcon }
          />
          View and Download our Engagement Letter
        </a>
      </div>
    </div>
  );
};

export default QuoteFormSuccess;
